import { render, staticRenderFns } from "./UsageTerms.vue?vue&type=template&id=16e398d7&scoped=true"
import script from "./UsageTerms.vue?vue&type=script&lang=js"
export * from "./UsageTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e398d7",
  null
  
)

export default component.exports